/* istanbul ignore file */
import { createAction } from '@reduxjs/toolkit';
import { Offer } from '../../entities';

export const updateSelectedTrialOffer = createAction<Offer>('offers/UPDATE_SELECTED_TRIAL_OFFER');
